<template>
  <wd-config-provider
    class="bg-page-bg"
    :theme="themeStore.theme"
    :class="themeStore.theme"
    :themeVars="themeVars"
  >
    <!-- <CustomLoading ref="loading" /> -->
    <slot />
    <CustomTabbar v-if="showTabbar" />
    <KFBtn />
    <wd-toast />
    <wd-message-box />
    <CommonPopup v-model="userStore.checkinPopup" :title="t('checkin.popupTitle')">
      <template #default>
        <view v-if="userStore.isLogined && checkinConfigData" class="p-16px box-border">
          <view class="text-16px text-navigate-textColor mb-16px flex items-center justify-between">
            <text>{{ t('checkin.continuousTask') }}</text>
            <text>
              {{ userStore.userInfo?.checkinContinue || 0 }}
              / {{ checkinRewards.length }}
            </text>
          </view>
          <view class="grid grid-cols-4 gap-8px mb-16px">
            <view
              class="checkin-item h-120px rounded-8px bg-navigate-menuTextBg flex flex-col items-center py-19px relative overflow-hidden"
              v-for="(item, index) in checkinRewards"
              :key="index"
              @click="() => onCheckin(item)"
            >
              <view class="text-13px text-navigate-menuTextColor">
                {{ t('checkin.day', { day: item.days }) }}
              </view>
              <img class="w-29px h-29px my-2px" src="@/static/images/mine/checkin.png" alt="" />
              <view class="text-14px text-navigate-textColor">
                +{{ formatAmount(item.amount) }}
              </view>
              <view
                class="absolute bottom-0 left-0 w-full min-h-20px flex justify-center items-center checkin-item-status"
                :class="{
                  'checkin-item-status-uncompleted':
                    item.days > userStore.userInfo?.checkinContinue,
                }"
              >
                <view class="text-12px text-white text-center">
                  {{
                    item.days > userStore.userInfo?.checkinContinue
                      ? t('checkin.uncompleted')
                      : t('checkin.completed')
                  }}
                </view>
              </view>
            </view>
          </view>
          <view v-if="dailyConfigData?.ID" class="bg-navigate-menuTextBg rounded-8px p-16px">
            <view
              class="text-14px text-navigate-textColor flex items-center justify-between mb-20px"
            >
              <view>{{ t('checkin.taskDate', { date: currentDay }) }}</view>
              <view
                class="text-12px text-navigate-menuTextColor border border-solid border-#303747 rounded-8px px-16px py-7px"
              >
                {{ t('checkin.inProgress') }}
              </view>
            </view>
            <view class="text-#FFAD04 text-15px">
              {{
                t('checkin.earn', {
                  amount: `+${formatAmount(dailyConfigData?.activityDaily?.reward)}`,
                })
              }}
            </view>
            <view class="line-gradient h-1px w-full my-16px"></view>
            <view class="flex items-center justify-between text-13px mb-4px">
              <view class="text-navigate-menuTextColor">{{ t('checkin.todayBet') }}</view>
              <view class="text-navigate-textColor">
                {{ formatAmount(userStore.userInfo.todayBet) }}/{{
                  formatAmount(dailyConfigData?.activityDaily?.requiredBet)
                }}
              </view>
            </view>
            <view class="flex items-center justify-between text-13px">
              <view class="text-navigate-menuTextColor">{{ t('checkin.todayDeposit') }}</view>
              <view class="text-navigate-textColor">
                {{ formatAmount(userStore.userInfo.todayPay) }}/{{
                  formatAmount(dailyConfigData?.activityDaily?.requiredDeposit)
                }}
              </view>
            </view>
          </view>
        </view>
        <view class="flex flex-col items-center justify-center pb-[50px]" v-else>
          <Empty :content="t('checkin.activityNotStarted')" />
        </view>
      </template>
    </CommonPopup>
  </wd-config-provider>
</template>

<script lang="ts" setup>
import type { ConfigProviderThemeVars } from 'wot-design-uni'
import CustomTabbar from '@/components/CustomTabbar/index.vue'
import KFBtn from '@/components/KFBtn.vue'
import { useThemeStore, useUserStore, useGameStore } from '@/store'
import { useLoginStore } from '@/store/modules/login'
import { currentPageIsTabbar, hideTabbar } from '@/utils/navigation'
import CommonPopup from '@/components/CommonPopup.vue'
import { getCheckinConfig, getPlayerCheckinInfo, postPlayerCheckin } from '@/service'
import { useI18n } from 'vue-i18n'
import { formatAmount, showModal } from '@/utils'
import Empty from '@/components/Empty.vue'
import dayjs from 'dayjs'
// import CustomLoading from '@/components/CustomLoading.vue'

// const loading = ref(null)

const currentDay = dayjs().format('YYYY-MM-DD')

const { t } = useI18n()
const gameStore = useGameStore()
const themeStore = useThemeStore()
const loginStore = useLoginStore()
const userStore = useUserStore()
const themeVars: ConfigProviderThemeVars = {
  // colorTheme: 'red',
  // buttonPrimaryBgColor: '#07c160',
  // buttonPrimaryColor: '#07c160',
}

const showTabbar = ref(true)

const checkinConfigData = ref<any>(null)
const dailyConfigData = ref<any>(null)

const checkinRewards = computed(() => {
  return checkinConfigData.value?.activityCheckin.rewards || []
})

const getCheckinConfigData = async () => {
  const res = await getCheckinConfig()
  if (res.code === 0) {
    checkinConfigData.value = res.data.checkin
    dailyConfigData.value = res.data.daily
  }
}

// 玩家签到配置
const playerCheckinInfo = ref<any>(null)
const getPlayerCheckinInfoData = async () => {
  const res = await getPlayerCheckinInfo()
  if (res.code === 0) {
    playerCheckinInfo.value = res.data.list
  }
}
// 签到
const onCheckin = async (item: any) => {
  if (item.days <= userStore.userInfo?.checkinContinue) return
  const res = await postPlayerCheckin()
  if (res.code === 0) {
    getPlayerCheckinInfoData()
    userStore.updateUserInfo()
  } else {
    showModal(res.msg)
  }
}

const refreshCheckinPopup = async () => {
  await getPlayerCheckinInfoData()
  await getCheckinConfigData()
  if (!checkinConfigData.value.ID) {
    userStore.checkinPopup = false
    return
  }
  if (!userStore.firstCheckin && checkinConfigData.value.ID) {
    userStore.firstCheckin = true
    userStore.checkinPopup = true
  }
}
onLoad(async () => {
  currentPageIsTabbar()
  showTabbar.value = hideTabbar.value
  if (!userStore.isLogined) return
  await getCheckinConfigData()
  await getPlayerCheckinInfoData()
  console.log(checkinConfigData.value)

  if (!checkinConfigData.value?.ID) {
    userStore.checkinPopup = false
    return
  }
  if (!userStore.firstCheckin && checkinConfigData.value?.ID) {
    userStore.firstCheckin = true
    userStore.checkinPopup = true
  }
})
// onMounted(()=> {
//   uni.$loading = {
//     show: (options) => loading.value?.show(options),
//     hide: () => loading.value?.hide()
//   }
// })
</script>

<style lang="scss" scoped>
:deep(.dark) {
  .checkin-item-status {
    background: rgba(255, 255, 255, 0.7);
  }
}
:deep(.light) {
  .checkin-item-status {
    background: rgba(0, 0, 0, 0.5);
  }
}
.checkin-item-status-uncompleted {
  color: #fff !important;
  background: #2283f6;
}
</style>
